import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function MusicTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['common_ui']);

  const tabs = [
    { id: 'music-generation', label: t('common_ui:tabs.music.generation'), path: '/music-generation' },
    { id: 'music-edit', label: t('common_ui:tabs.music.edit'), path: '/music-edit' },
  ];

  const getActiveTab = () => {
    if (location.pathname === '/music-edit') return 'music-edit';
    return 'music-generation';
  };

  return (
    <div className="p-4 border-b border-border-subtle">
      <nav className="flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`py-1 px-1 border-b-2 font-medium text-lg transition-colors cursor-pointer ${getActiveTab() === tab.id
              ? 'border-primary text-gray-50'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-300'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
